export default function buildDocumentTitle(parts: Array<string>): string {
  return parts.join(" / ");
}
